import { FormGroup } from '@angular/forms';
export class SaveForm {
  public Form: FormGroup;
  public Position: number;
  public Module: number = 1; // na czas testów
  public Type: number;
  public IsPrint: boolean;
}
